//@service
import {bind,RepositoryInterface} from '@/service/utils'
export const kanoonService= {
  get kanoonRepository() {
    return bind(() => import('./kanoon.repo'), RepositoryInterface);
  },
  get competencyRepository() {
    // Delay loading until a method of the repository is called.
    return bind(() => import('./competency.repo'), RepositoryInterface);
  },
  get enumRepository() {
    return bind(() => import('./enum.repo'), RepositoryInterface);
  },
  get centerExecuteCompetencyRepository() {
    return bind(() => import('./centerExecuteCompetency.repo'), RepositoryInterface);
  },
  get centerExecuteCompetencyIndicatorsRepository() {
    return bind(() => import('./centerExecuteCompetencyIndicator.repo'), RepositoryInterface);
  },
  get centerExecuteCompetencyIndicatorEvidencesRepository() {
    return bind(() => import('./centerExecuteCompetencyIndicatorEvidence.repo'), RepositoryInterface);
  },
  get centerExecuteCaseOverviewRepository() {
    return bind(() => import('./centerExecuteCaseOverview.repo'), RepositoryInterface);
  },
  get centerExecuteCompetencySuggestScoreRepository() {
    return bind(() => import('./centerExecuteCompetencySuggestScore.repo'), RepositoryInterface);
  },
  get centerExecuteCaseFinalTextRepository() {
    return bind(() => import('./centerExecuteCaseFinalText.repo'), RepositoryInterface);
  },
  get centerExecuteCaseStatusRepository() {
    return bind(() => import('./centerExecuteCaseStatus.repo'), RepositoryInterface);
  },
  get centerExecuteCandidateOverviewRepository() {
    return bind(() => import('./centerExecuteCandidateOverview.repo'), RepositoryInterface);
  },
  get centerExecuteCompetencyIndicatorEvidenceLikeRepository() {
    return bind(() => import('./centerExecuteCompetencyIndicatorEvidenceLike.repo'), RepositoryInterface);
  },
  get centerExecuteReportRepository() {
    return bind(() => import('./centerExecuteReport.repo'), RepositoryInterface);
  },
  get reportSettingsRepository() {
    return bind(() => import('./reportSettings.repo'), RepositoryInterface);
  },
}

